import { reactive } from "vue";
import { Building } from '../interfaces/building.interface';

export const topBarState = {
    state:reactive({
        title:'',
        building:''
    }),
    updateTitle(title:string) {
        this.state.title = title;
    },
    updateBuildingName(building:Building) {
        this.state.building = building.name;
    }
}